export const DEFAULT_MANUAL_BOOKING_COUNTRY_CODE = '+48';
export const DEFAULT_MANUAL_BOOKING_LOCAL_LENGTH = 9;

/** Select value for "New client" — not a real user id. */
export const MANUAL_BOOKING_NEW_CLIENT = '__new__';

export function isManualBookingNewClient(clientId: string | null | undefined): boolean {
  return clientId === MANUAL_BOOKING_NEW_CLIENT;
}

/** Returns a real booking-client user id, or null for new/guest. */
export function resolveManualBookingClientUserId(
  clientId: string | null | undefined,
): string | null {
  const trimmed = clientId?.trim();
  if (!trimmed || isManualBookingNewClient(trimmed)) {
    return null;
  }
  return trimmed;
}

export function composeManualBookingPhoneNumber(
  countryCode: string,
  localDigits: string,
): string | null {
  const trimmed = localDigits.replace(/\D/g, '');
  if (!trimmed) {
    return null;
  }
  return `${countryCode}${trimmed}`;
}

export function buildManualGuestBookingFields(params: {
  userId?: string | null;
  phoneNumber?: string | null;
  sendSms?: boolean;
}): {
  userId?: string;
  phoneNumber?: string;
  sendSms?: boolean;
} {
  const userId = params.userId?.trim();
  if (userId) {
    const phoneNumber = params.phoneNumber?.trim();
    const result: { userId: string; phoneNumber?: string; sendSms?: boolean } = { userId };
    if (phoneNumber) {
      result.phoneNumber = phoneNumber;
    }
    // sendSms is valid for resolved users even when phoneNumber is omitted.
    if (params.sendSms != null) {
      result.sendSms = params.sendSms;
    }
    return result;
  }

  const phoneNumber = params.phoneNumber?.trim();
  if (!phoneNumber) {
    return {};
  }

  const result: { phoneNumber: string; sendSms?: boolean } = { phoneNumber };
  if (params.sendSms != null) {
    result.sendSms = params.sendSms;
  }
  return result;
}

export function resolveManualBookingShareUrl(
  bookingLinkUrl?: string | null,
): string | null {
  const trimmed = bookingLinkUrl?.trim();
  return trimmed ? trimmed : null;
}

export function hasManualBookingClient(userId?: string | null): boolean {
  return Boolean(userId?.trim());
}
